import type { FaqEntry } from './en'

export const deFaq: FaqEntry[] = [
{
    id: 'what-is-radiri',
    question: 'Was ist Radiri?',
    answer: `Radiri bietet lokale und regionale Nachrichten für Leute, die an einem Ort leben, aber nicht 
    die Hauptsprache dieses Ortes sprechen. Wir berichten nur über genaue Fakten, aber das Schreiben der Artikel und 
    die Content-Erstellung übernimmt unsere KI. Dadurch können wir unsere Online-Zeitung für ein monatliches 
    Abo von nur 3 EUR anbieten – ein Zehntel bis ein Fünfzehntel der üblichen Abokosten für 
    die digitale Ausgabe traditioneller, seriöser, kostenpflichtiger Zeitungen in Europa.`,
  },
  {
    id: 'why-radiri',
    question: 'Warum macht ihr das?',
    answer: `Wir glauben, dass lokale und regionale Nachrichten oft zu wenig Beachtung finden und häufig 
    von der emotional aufgeladenen Berichterstattung über globale und geopolitische Ereignisse in den Schatten gestellt werden.
    Wir glauben auch, dass Menschen mit eingeschränktem Zugang zu regionalen Nachrichten in der Landessprache sich eher 
    von der Gemeinschaft, in der sie leben, entfremdet fühlen und von dieser Gemeinschaft eher als 
    Fremde angesehen werden. Uns ist bewusst, dass eine regelmäßige und verlässliche Berichterstattung über lokale Nachrichten 
    in anderen Sprachen als der Hauptsprache eines Ortes bisher nicht 
    wirtschaftlich tragbar war, und das wollen wir mit Hilfe von KI ändern.`,
  },
  {
    id: 'ai-reliability',
    question: 'Ich habe gehört, dass sich KI Dinge ausdenken kann. Sollte ich euren Nachrichten vertrauen?',
    answer:
      `Wir nutzen KI für verschiedene Zwecke: Um Quelleninhalte in Faktenberichte, 
      Kommentare, Meinungen usw. einzuteilen. Um Quelleninhalte nach Ereignissen oder Fakten zu gruppieren, über die sie berichten. Um 
      eigene Artikel in der Zielsprache zu schreiben, ohne zu kopieren oder zu übersetzen. Um Bilder zu generieren, 
      etwa als Bleistift- oder Kohlezeichnungen, damit der Inhalt inspirierend und die Zeitung 
      leichter zu lesen ist.

  Unsere KI wird nur eingesetzt, um die Inputs zu verarbeiten, zusammenzufassen und die 
      Artikel strikt basierend auf den Inputs zu verfassen. Sie trägt niemals zu den tatsächlichen Inhalten der Nachrichten bei.`,
  },
  {
    id: 'data-sources',
    question: 'Woher bekommt ihr eure Daten?',
    answer:
      `Unser System verarbeitet Ankündigungen und Nachrichten aus dem Netz, einschließlich öffentlicher Websites von 
      Behörden, Museen, Unternehmen und auch anderen Zeitungen. Wir werten auch Social-Media-Accounts 
      von handverlesenen, verlässlichen Quellen aus, wie zum Beispiel Regierungsbehörden, Eisenbahngesellschaften 
      und mehr.`,
  },
  {
    id: 'price',
    question: 'Warum könnt ihr den Zugang nicht kostenlos anbieten?',
    answer:
      `Die einzige Möglichkeit, eine kostenlose Zeitung anzubieten, bestünde darin, dir Werbung zu zeigen. Wir werden niemals Werbung schalten, weil 
      wir unsere Leser als unsere Kunden betrachten, nicht als unser Produkt. Guter Journalismus wird von 
      seinen Lesern bezahlt, nicht von Leuten, die die Meinung dieser Leser beeinflussen wollen. 3 EUR für eine hochwertige 
      Zeitung ist unglaublich wenig im Vergleich zu allem, was es an seriösen, 
      kostenpflichtigen Zeitungen gibt. Wir glauben jedoch, dass uns Skaleneffekte 
      ermöglichen werden, den Preis im Laufe der Zeit noch weiter zu senken.`
  },
  {
    id: 'personal-data',
    question: 'Welche Daten sammelt ihr über mich?',
    answer:
      `Wir speichern nur die minimal nötigen Daten, damit du auf mehreren 
      Geräten auf dein Abo zugreifen kannst und wir überprüfen können, dass du ein Abonnent bist. Dazu gehört eine E-Mail-Adresse, die du uns 
      zur Verfügung stellst, was wir nicht zuletzt tun, um Missbrauch durch Bots und Fake-Accounts zu vermeiden. (Du kannst uns 
      natürlich einen E-Mail-Alias geben, der deine Identität nicht preisgibt.) Wir geben keine 
      dieser Daten an irgendjemanden weiter. Wir sammeln keine Daten darüber, was du liest, suchst oder 
      anklickst. Der Grund, warum wir das nicht brauchen, ist, dass wir dir keine Werbung zeigen, sodass eine Personalisierung 
      unnötig ist.`
  },
  {
    id: 'political-bias',
    question: 'Wie vermeidet ihr politische Voreingenommenheit?',
    answer:
      `Unsere KI ist speziell darauf ausgelegt, den Grad an Objektivität in Quelleninhalten anhand von 
      Quelle und Schreibstil zu erkennen: Kommentar vs. Expertenmeinung vs. Faktenbericht. Zum Beispiel wird die
      Ankündigung einer neuen Ausstellung auf der Seite eines bekannten und handverlesenen Museums als 
      verlässlicher Fakt betrachtet, während Meinungen in einem Interview auf einer Nachrichtenwebsite als 
      Meinung der befragten Person angesehen werden. Social-Media-Blogs und Posts von Einzelpersonen 
      und Influencern werden aus Prinzip überhaupt nicht in unsere Quellen aufgenommen.

Wir generieren Artikel nur basierend auf Quelleninhalten, die als Faktenberichte erkannt wurden. Wenn wir 
      Kommentare von öffentlich anerkannten Quellen finden, kann unsere KI diese als Referenz 
      und mit Quellenangabe einbinden und sie als Kommentar oder Meinung kennzeichnen.`
  },
  {
    id: 'copyright',
    question: 'Wie schützt ihr die geistigen Eigentumsrechte eurer Quellen?',
    answer:
      `Wir kopieren oder übersetzen niemals Texte aus Originalquellen, außer als direkte Zitate in 
      doppelten Anführungszeichen und mit Quellenangabe. Unsere KI ist speziell darauf ausgelegt zu erkennen, 
      ob ein Quelleninhalt Faktenberichte vs. Kommentare, Meinungen und literarische 
      Werke darstellt, und wir beziehen nur Faktenberichte mit ein, wenn wir entscheiden, worüber wir in unseren Artikeln berichten.
      Unsere KI schreibt eigenständige Artikel, separat für jede Sprache, die wir unterstützen, und nutzt diese Fakten 
      als Input, anstatt die Originale zu kopieren oder zu übersetzen.`
  },
  {
    id: 'ai-generated-images',
    question: 'Warum verwendet ihr KI-generierte Bilder?',
    answer:
      `Wir haben keine Fotografen fest angestellt und wollen keine Bilder von anderen klauen. 
      Wie traditionelle Medien nutzen auch Publikationen symbolische Bilder, um Geschichten zu ergänzen – ein Artikel über ein Feuer 
      zeigt Flammen, nicht zwingend den tatsächlichen Ort des Geschehens. Wir nutzen KI, um diese symbolischen Bilder 
      ethisch und für geringe Kosten zu generieren und so den Kern jeder Geschichte einzufangen, ohne Originalfotos 
      oder Lizenzen zu benötigen. Wir hoffen, du findest sie ansprechend, hilfreich und manchmal auch unterhaltsam. Bitte nutze
      die Feedback-Buttons bei jedem Bild, um uns wissen zu lassen, wie es dir gefallen hat!`,
  },
]
